/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-return */ /* eslint-disable @typescript-eslint/restrict-template-expressions */ import opm from 'portal-common/config/opm';
import { API_PREFIX } from 'portal-common/constants';
import request from 'portal-common/service/fetch';
import { ACTIVITY_TYPE } from '../common/constants';
export var FETCH_PREFIX = {
    COMMON: "".concat(API_PREFIX, "/common"),
    ASK: "".concat(API_PREFIX, "/ask"),
    API: '/render/api/configsolution'
};
export var getOpmList = function(payload) {
    var eventType = payload.eventType;
    var data = payload;
    var positionId = opm.coupon.otherTips;
    if (ACTIVITY_TYPE.COUPON === eventType) {
        // 代金券类型
        positionId = opm.coupon.couponInfo;
    } else if (ACTIVITY_TYPE.DISCOUNT === eventType) {
        // 折扣类型
        positionId = opm.coupon.discountTips;
    } else if (ACTIVITY_TYPE.FULLBACK === eventType) {
        // 满返类型
        positionId = opm.coupon.fullbackTips;
    }
    data = Object.assign(payload, {
        positionId: positionId
    });
    return request.post("".concat(FETCH_PREFIX.API, "/getOpmList"), data);
}; // 问答详情页添加文章
export var createOrder = function(payload) {
    return request.post("".concat(FETCH_PREFIX.API, "/createOrder"), payload);
}; // 详情页添加评论
